module.exports = __webpack_public_path__ + "img/img_join_05.1ad08757.jpg";